exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-568bd7b7].el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color: #fff;border-radius: 20px 20px 0 0;margin-top: 10px;margin-left: 10px;\n    background-color: #497af2;\n}\n.isreturn[data-v-568bd7b7]{padding-left: 10px !important;cursor: pointer;background:#f5f6f7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-568bd7b7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/record/eachExerciseRecordAll.vue
// module id = 1619
// module chunks = 0